import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  targetFaq;
  faqs = [
    {
      title: "Where does the money go?",
      body: "100% of your purchase goes directly to participating school athletic departments. Just like your admission to a game, you are helping to buy uniforms, equipment and opportunities for athletes. If you’d like, you’re welcome to make an additional contribution to support your school – just think of what you’d have spent at the 50/50 and concession stand!"
    },
    {
      title: "Can I view games on my TV?",
      body: "If you are able to Airplay, Screen Share, ChromeCast, MirrorPlay or get your mobile or tablet devices screen onto your TV, than yes! Just connect your device as you normally would (or google how) and then pull up the game on your phone, tablet or computer.\n" +
        "You can also use various adaptors and cords to hardwire in a TV input – usually an HDMI port. Google and Amazon will get you what you need!"
    },
    {
      title: "What devices can I watch games on?",
      body: "You can view games on any device with an internet browser. Simply log in with your username and password to view games on your phone or tablet, laptop or desktop computer.\n"
    },
    {
      title: "How many people can watch the game?",
      body: "Although your username is limited to one viewing instance at a time, there’s no limit to how many people can enjoy the single stream (except the size of your living room, perhaps). But remember, attendance limitations at live games are not up to the school and the lack of admission will cause a financial hardship. If you’re hosting a large group, consider donating a little extra to chip in for the loss of additional streaming purchases."
    },
    {
      title: "How much data will this use?",
      body: "Streaming video can be a little data hungry. Although this uses no more data per minute than streaming a Youtube video or TikTok, that data adds up over a 2-3 hour game. We’d recommend you make sure you are using Wi-Fi to view the game or risk data throttling or overages."
    }
  ]
  constructor() { }

  ngOnInit() {
  }

  openFaq(i) {
    this.targetFaq = i;
  }

}
